<template>
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 550 445"
    xml:space="preserve"
  >
    <g>
      <path
        fill="#b3e6fc"
        d="M450.7,323.1l-1.3,4.4c-13.8,46.1-43.4,83.2-86.8,100.6c-28.9,11.6-57,15.8-83.7,13.4c0,0,0,0,0,0
		c-1-0.1-2-0.2-3-0.3c-68.4-7.4-126.7-58-162.3-137.6c-26.9-60.1-27.5-129.5-11-186.4l2.5-8c5.2-15.9,11.7-30.6,19.3-43.8
		c5.1-8.7,10.6-16.7,16.7-23.9c0.5-0.6,1-1.2,1.5-1.7c2.9-3.4,5.9-6.5,9-9.4c7.1-6.8,14.7-12.4,22.7-16.7c0.9-0.5,1.8-1,2.7-1.4
		c1.7-0.9,3.5-1.7,5.4-2.4c0,0,0,0,0.1,0c7.8-3.1,16.4-5.1,25.7-5.9c0,0,0,0,0,0c3.6-0.3,7.4-0.5,11.2-0.5c6.7,0,13.8,0.6,21,1.6
		l0,0c11.6,1.7,23.6,4.6,35.8,8.8c22.7,7.7,46,19.5,68,34.8c6.7,4.6,13.2,9.6,19.5,14.9C393,88,418.5,119,434.5,154.9
		C460.1,212,464.7,272.6,450.7,323.1z"
      />
      <g>
        <path
          fill="#608437"
          d="M214.2,298.6c3.5,2,7.5,1.9,11.2,3.5c8.7,3.8,16.8,8.5,24.2,14.4c5.8,4.6,10.9,10,15.2,16
			c3.4,4.8,6.7,9.7,10.4,14.9c1.3-2.6,0.3-4.5-0.5-6.4c-3.4-7.6-5.8-15.5-7.9-23.5c-1.3-5.3-3.4-10.3-4.7-15.6
			c-4.7-18.2-6.9-36.6-3.2-55.2c1.2-2.5,2.5-5,3.7-7.5c0.5-0.9,1.4-1.1,2.2-0.8c0.9,0.3,1.2,1,1,2c-0.4,1.9-0.7,3.8-1,5.7
			c-2.6,6.2-2.8,12.8-2.7,19.4c0.2,14.3,2.6,28.4,6.9,42.1c3.4,10.9,6.8,21.8,10.5,32.6c3.2,9.3,6.8,18.5,10.3,27.7
			c1.3,3.3,0.4,7.1,2.6,10.1c1.9,0.1,2-1.5,2.3-2.7c1.6-5,3.8-9.8,4.8-15c0.6-3,2-5.8,2.8-8.7c3.4-12.4,3.8-25.1,3.5-37.9
			c-0.1-3.9-0.7-7.9-1.5-11.8c-2.2-10.3-1.3-20.5,0.8-30.7c1-4.6,3.3-8.7,5.7-12.5c4.4-6.8,9.2-13.3,15.3-18.9
			c2.6-2.4,6.1-2.5,8.2-5.4c1.7,2.6,1.7,4.5,0.5,7c-3.7,7.3-4.2,14.9-1,22.7c2.8,6.9,5.7,13.8,7.6,20.9c3.5,12.8,3.3,25.5-1.9,38
			c-5.6,13.5-13,25.9-22.7,36.9c-5.1,5.7-10.3,11.3-15.4,17.1c-1.7,2-3.4,4.1-4.7,6.3c-1.8,3-3.2,6.2-1.8,10
			c0.9,2.5,0.6,5.2,0.3,7.7c1.8,0.7,2-0.6,2.4-1.5c8.5-14.9,20.2-26.2,35.7-33.8c12.4-6,24.7-12.4,36.9-18.7
			c5-2.6,10.3-4.9,14.2-9.3c0.4-0.4,1.3-0.7,1.8-0.5c0.9,0.3,1.1,1.2,1.1,2.1c0.2,3.9-1.3,7.4-2.7,10.8
			c-5.2,12.7-12.4,24.1-21.8,34.2c-10.7,11.5-24.4,15.8-39.2,18.1c-6.3,1-12.4,2.6-18.5,4.4c-1.7,0.5-3.3,0.9-4.8,2.1
			c-2.6,2.1-4.6,4.1-4.8,8c-0.4,7.9-3.6,14.7-9,20.5c-2.6,2.8-6.9,4.5-10.8,3.9c-0.1-1.9,1.8-2.3,2.7-3.5c1.5-1.9,1.5-3.2,0.4-5.8
			c-1.7-3.9-3-8.1-5.1-11.9c-2.4-4.5-5.5-8.2-9.2-11.8c-9.8-9.6-22-15.2-33.7-21.6c-9.9-5.4-18.7-12.1-26.2-20.4
			c-4.3-4.7-8.6-9.3-12.9-14c-7.3-8-13.4-16.8-17-27.2c-0.4-1.2-1-2.4-1.5-3.6c-0.3-1-0.3-2.2-0.9-3.1c-1.1-1.8-2.5-3.5-3.7-5.3
			c-0.3-0.5-0.4-1.4-0.2-1.7c0.3-0.4,1.3-0.6,1.7-0.4c1.1,0.5,2.3,1.2,3.2,2c2.3,2,4.4,4,6.6,6.1c3,3.5,6.7,6.4,10.6,8.6
			c6.2,3.6,13.1,6.1,19.9,8.4c11.2,3.8,22.5,7.4,32.6,13.9c8.3,5.4,15.9,11.5,20.9,20.4c1.4,2.5,3,4.8,4.5,7.2
			c7.7,12.6,12.6,25.9,12.1,40.9c-0.1,3.6-0.2,7.4,2.4,10.3c1.4,0.1,1.9-0.7,2.4-1.4c2.5-3.8,3.3-8,4.1-12.4
			c1.8-10.4-1-20.4-2.1-30.5c-0.4-4-1.6-7.7-3.8-11.1c-1.4-2.2-2.4-4.7-3.6-7c-8.7-15.8-18-31.2-31.7-43.3
			c-8.6-7.6-18-13.9-29.1-17.5c-4.4-1.4-9.2-1.3-13.2-3.8c-0.2-1-0.6-1.6,0.7-2.5C209.3,298,211.9,299.4,214.2,298.6z"
        />
        <path
          fill="#ffffff"
          d="M335.9,191c0.2-2.5-0.1-4.8-1.1-7c-4-9.2-11.8-13-21.7-10.7c-3.1,0.7-3,0.7-4.1-2.4
			c-2.3-6.7-5.6-12.9-11.2-17.4c-7.6-6.1-16.5-3.8-19.1,3.3c-0.5,1.4-1.6,2.6-2.4,3.9c-1.7,2.8-3,3.2-4.6,0.8
			c-3.3-4.8-8.1-7.3-12.9-9.9c-4-2.2-8-2.6-11.4-1.5c-1.3,0.4-2.6,1.1-3.7,2c-2.1,1.6-3.9,4-5.2,7c-1.2,2.7-1.5,5.5-2.1,8.3
			c0,0.1-0.1,0.2-0.1,0.3l0,0c-0.3,1.4-0.9,2.2-1.7,2.4c-0.6,0.1-1.4-0.2-2.3-0.9c-3.1-2.3-6.8-3.2-10.2-4.3
			c-7.2-2.1-11.5-0.8-14.8,5.7c-1.5,3-1.9,6.3-1.5,9.6c0.2,2,0.5,3.9,0.1,5.9c-1,4.6,0.7,8.6,2.8,12.6c1.5,2.7,3,5.4,4,8.2
			c1.1,3,2.7,5.6,4.8,7.8c6,6.3,11.6,13,19.1,17.9c4.6,3,9.5,5.2,14.4,7.7c3.2,1.6,6.1,3.4,8,6.5c1.2-2.5,2.5-5,3.7-7.5
			c0.5-0.9,1.4-1.1,2.2-0.8c0.9,0.3,1.2,1,1,2c-0.4,1.9-0.7,3.8-1,5.7c2.8-1,5.2-2.7,8.4-3.3c14.2-2.7,26.9-9.2,38.8-17.1
			c5.6-3.7,9.6-9,14.1-13.7C331.7,206.2,335.4,199.3,335.9,191z M260.6,184.4c-1.7,5.9-5.4,8-10.6,5.8c-1.6-0.7-3-1.8-4.4-2.8
			c-0.7-0.3-1-0.8-1.1-1.5l0,0c-2.7-1.4-3.3-3.9-2.5-6.4c0.8-2.6,2.9-3.8,6-3.9c5.8-0.1,11,2.6,13.4,7.9
			C261.4,183.6,260.8,184.1,260.6,184.4z M288,188.2c-1.2,5-2.5,6-6.9,5.5c-2.5-0.3-4.5-1.5-6.5-2.9c-1-0.8-0.9-1.9-0.7-3
			c-0.4-3.5,1.4-5.9,4.1-7.7c3.7-2.5,8.7-0.6,10,3.6C288.5,185.2,288.4,186.6,288,188.2z"
        />
        <path
          fill="#ffffff"
          d="M219,278.9c0.2-9-2-17.3-9.2-23.6c-2.8-2.4-5.5-5-8-7.8c-4.5-4.9-9.9-7.7-16.5-8.2c-6.8-0.5-10.9,3.2-12.3,10
			c-1,4.8,0.1,9.5,0.6,14.4c-2.7,0.2-5,0.8-7.4,0.6c-6-0.5-9.3,2.9-11.9,7.6c-4,7.1-2.2,10.9,3.1,15.5c4.9,4.2,5,4.1,1.2,9.6
			c-0.3,0.4-0.5,0.7-0.7,1.1c-4.5,6.9-2.9,15.3,3.7,20.2c3.6,2.7,7.8,2.8,11.9,3.2c-0.3-1.1-0.3-2.2-0.9-3.1
			c-1.1-1.8-2.5-3.5-3.7-5.3c-0.3-0.4-0.4-1.4-0.2-1.7c0.3-0.4,1.3-0.6,1.7-0.4c1.1,0.5,2.3,1.2,3.2,2c2.3,2,4.4,4.1,6.6,6.1
			c6.8-1.2,12.1-5.4,17.5-9.3c3.1-2.3,5.6-5.3,8.4-8c-0.2-1-0.5-1.6,0.7-2.5c2.4-1.6,5-0.1,7.3-0.9c0.7-2.1,1.2-4.2,1.9-6.3
			C217.4,287.9,218.9,283.4,219,278.9z M186.1,286.9c-2.1,2.8-4.8,0.9-7.2,0.7c-1.8,0.4-3.9,1.9-5.5,0c-1.7-2.1-2-4.3-1-7.2
			c1.1-2.9,2.4-5,5-6.5c2.2-1.3,2.9-0.9,4.4,2.4c1.7-0.5,3.3-0.9,5.3-1.5C189.2,279.1,188.9,283.1,186.1,286.9z"
        />
        <path
          fill="#fa8d5b"
          d="M260.6,184.4c-1.7,6-5.4,8-10.6,5.8c-1.6-0.7-3-1.8-4.4-2.8c-0.1-0.7-0.3-1.3-1.1-1.5l0.1,0.1
			c1.6-4.4,3.8-6,7.5-5.2C255.2,181.5,257.9,182.9,260.6,184.4z"
        />
        <path
          fill="#fa8d5b"
          d="M288,188.2c-1.2,5-2.5,6-6.9,5.5c-2.5-0.3-4.5-1.5-6.5-2.9c-1-0.8-0.9-1.9-0.7-3c1.1-0.3,1.8-1,2.7-1.7
			c2.6-2.2,5.4-2.6,8.1-0.9C285.9,185.9,286.9,187.1,288,188.2z"
        />
        <path
          fill="#fa8d5b"
          d="M181.8,276.4c1.7-0.5,3.3-0.9,5.3-1.5c2.2,4.2,1.9,8.2-0.9,12c-2.1,2.8-4.8,0.9-7.2,0.7
			C175.9,282.9,178.5,279.6,181.8,276.4z"
        />
      </g>
      <g>
        <path
          fill="#ffcd59"
          d="M280.4,90.7c-1.7-1.7-7.1-4.8-7.1-4.8c-0.5-0.8-2.5-6.4-4-9c-0.2-0.4-0.3-0.8-0.6-1.1
			c-4.2-6.2-11.2-8.8-18.3-6.1c-7.8,3.1-13.4,9-17.7,15.8c-3.7,5.7-8.6,9.7-14.2,13.2c-5.2,3.3-11.2,3.8-16.9,5.1
			c-8,1.8-16.2,3.2-24.5,3.2c-3.9,0-8,0.2-11.9,1.8c0.8,7.4,4.8,13.2,8.7,18.9c9,12.9,22.2,19.1,37,22.5c6.3,1.5,12.6,0.2,18.9,0
			c0-2.4-1.3-4.9,0.8-7.3c0.2,0.1,0.3,0.2,0.5,0.4c0.1,0.1,0.2,0.1,0.2,0.2c0,0,0,0,0,0.1c0.2,0.1,0.3,0.3,0.4,0.4
			c0.2,0.2,0.3,0.5,0.4,0.7c0.1,0.2,0.1,0.4,0.2,0.6c0.1,0.2,0.2,0.5,0.2,0.7c0.1,0.4,0.2,0.8,0.3,1.2c0,0.2,0.1,0.3,0.1,0.4
			c0,0.2,0.1,0.3,0.2,0.5c3,0.8,5.9-0.8,9-0.4c-0.2-1.2-0.4-2.4-0.6-3.7c0-0.1,0-0.3,0-0.4c0-0.1,0-0.2,0-0.3c0-0.1,0-0.3,0.1-0.4
			c0-0.1,0-0.1,0.1-0.2c0,0,0,0,0,0c0-0.1,0.1-0.1,0.1-0.2c0-0.1,0.1-0.1,0.2-0.2c0.1,0,0.1-0.1,0.2-0.1c0.1,0,0.1-0.1,0.2-0.1
			c0.2-0.1,0.4-0.1,0.6-0.1c0.1,0,0.2,0.1,0.4,0.1c0.3,0.1,0.6,0.4,0.8,0.6c0.1,0.1,0.2,0.2,0.3,0.4l0,0c0.2,0.3,0.5,0.7,0.7,1
			c0.2,0.4,0.5,0.7,0.7,1c3.8-2.3,7.2-5.1,10.1-8.4c7.4-8.5,12.9-17.9,14.7-29.1c0.5-3.2,0.8-7.1,1.6-10.1c0.2-0.4,4.5-2.7,8-6.3
			C280.5,91.1,280.5,90.9,280.4,90.7z M237.4,125.5L237.4,125.5c-0.5,2.5-2.3,2.3-4.1,2c-0.7,3.2-3.7,3.7-5.9,4
			c-12,1.7-22.6-1.1-30.6-10.9c-1.5-1.8-3-3.5-4.5-5.3c-1.2-1.4-0.4-2.5,0.9-2.9c2.2-0.7,4.5-1.5,6.8-1.7c9.2-0.7,18.4-2.5,27.6-1.9
			c0.6,0.1,1.2,0.3,3.2,0.8c-12.1,2.4-23.4,0.9-34.2,5c1.9,4.9,5.7,8.2,10,10.6c7.6,4.4,15.7,6,24.3,2.6c0.7-0.3,1.6-0.2,2.5-0.3
			C234.2,125.8,235.6,125.2,237.4,125.5C237.4,125.4,237.4,125.4,237.4,125.5C237.4,125.4,237.4,125.4,237.4,125.5
			C237.4,125.4,237.4,125.4,237.4,125.5z M237.9,125.3c-0.1,0.1-0.2,0.1-0.4,0.1c0.2-0.2,0.3-0.3,0.6-0.4
			C238,125.1,237.9,125.2,237.9,125.3z M257.6,93.9c-3.1-0.5-4.8-2.8-4.4-5.8c0.4-2.8,3.2-4.8,5.9-4.3c1.2,0.2,2.3,1,3.2,2
			c1,0.9,1.8,2.3,1.7,3.5c0.1,0.4,0.1,0.8,0,1.2C263.5,93.2,261,94.5,257.6,93.9z"
        />
        <path
          fill="#608437"
          d="M234.7,157.3c0.7,4.4,1.4,8.7,2,13.1c0,0.2-0.2,0.3-0.6,1c-3.5-2.7-3.6-6.9-4.8-10.5
			c-0.2-3.6-0.4-7.2-1.4-10.8c0-2.4-1.3-4.9,0.8-7.3c2,1.3,1.8,3.5,2.6,5.3C233.7,151.2,234.2,154.2,234.7,157.3z"
        />
        <path
          fill="#608437"
          d="M250.5,155.9c0.2,1.2,0.6,2.3,0.7,3.5c0.1,1.4-0.6,2.2-2.2,1.8c-2.9-3.5-5.4-7.1-5.9-11.8
			c-0.1-0.6-0.6-1.1-0.9-1.6c-0.2-1.2-0.4-2.4-0.6-3.7c-0.1-0.9,0-1.7,0.9-2.1c0.9-0.3,1.5,0.4,2,1.1c0.5,0.7,0.9,1.4,1.4,2
			C246.7,149.1,248.2,152.7,250.5,155.9z"
        />
        <path
          fill="#b3e6fc"
          d="M263.9,89.7c-0.3,2.1-2.2,3.1-4.9,2.6c-2.4-0.4-3.7-2.2-3.4-4.4c0.3-2.1,2.5-3.7,4.5-3.3
			c0.7,0.2,1.4,0.5,2,1.1c0.9,1,1.6,2.3,1.7,3.5C264,89.4,263.9,89.6,263.9,89.7z"
        />
        <path
          fill="#608437"
          d="M263.9,89.7c-0.3,2.1-2.2,3.1-4.9,2.6c-2.4-0.4-3.7-2.2-3.4-4.4c0.3-2.1,2.5-3.7,4.5-3.3
			c0.7,0.2,1.4,0.5,2,1.1c1,0.9,1.8,2.3,1.7,3.5C264,89.4,263.9,89.6,263.9,89.7z"
        />
      </g>
      <g>
        <path
          fill="#608437"
          d="M387,276.8l-0.1-0.1c0,0,0,0,0.1,0C387,276.8,387,276.8,387,276.8z"
        />
        <path
          fill="#608437"
          d="M449.4,327.5c-1.8-1.1-3.6-2.1-5.3-3.3c-14.2-9.1-26.4-20.4-36.2-34.2c-1.2-1.6-2.1-4-3.7-4.7
			c-5.8-2.8-11-6.7-17.3-8.6c-0.2-0.8-0.7-1.2-1.6-1c-5.2-6.9-11.5-13.3-13.5-22.2c3.7-0.3,6.1,2.2,8.4,4.5c3.3,3.4,7.5,5.6,11,8.7
			c0.5,0.5,1.5,0.4,3,0.8c-1.1-3.9-2.1-7.3-3-10.7c-1-3.9-1.6-8-3.2-11.8c-1.6-3.9-6-5.3-9-8c-11.2-10-17.4-22.5-20-37
			c-0.8-4.5-2.2-8.7-3.5-13c-0.3-1.2-0.8-2.3-1.1-3.5c-0.4-2.4,1.1-5.3,3.3-5.9c2.3-0.7,3.4,1.2,4.2,2.7c4.6,8.4,9.7,16.5,13,25.6
			c2.6,7,7.1,12.8,11.5,19.4c2.1-6.4,2.3-12.7,4.9-18.2c0,0,0-0.1,0.1-0.2l0,0l-0.1,0c0,0.1,0,0.2,0,0.2c0.8,4.8,0.6,9.6,0.6,14.5
			c-0.1,11.1,0.8,22.1,4.1,32.7c0.7,2.1,1.4,4.2,2.4,7.1c3.1-6.8,5.7-13,9.1-18.8c7.5-13.2,15.6-25.9,26.7-36.4
			c0.6-0.6,1.2-1.1,1.8-1.7c1.4-1.3,3.4-2.2,5-1.3c1.9,1.1,1.2,3.3,0.6,5c-2.1,5.5-4,11.2-6.6,16.5c-6,12.1-13.2,23.6-21.5,34.2
			c-3,3.9-6.4,7.9-12.4,8.8c6.3,13.3,13.9,25.1,25,35.4c0-1.7,0.2-2.8,0-3.7c-1.9-6.4-1.5-13.1-0.7-19.5c0.7-6.2,0.8-12.6,3.1-18.6
			c1.1-2.8,3.2-5.1,3.5-8.3c0.2-1.5,2-2.4,3.8-2.5c1.8-0.1,2.8,1.1,3.3,2.4c2.8,7.2,6.4,14.3,5.1,22.4c-1.2,7.9-2.6,15.7-4.9,23.4
			c-0.8,2.5-2.6,4.5-4.5,6.5c-3.2,3.3-3,3.2,0.3,6.3c4.7,4.5,10,8.4,15.6,11.6L449.4,327.5z"
        />
        <path
          fill="#fa8d5b"
          d="M391.4,206.9l0.1,0.1c-2.5-3.4-6.1-5.9-8.2-9.8c-3.8-7-3.7-14.1-2.8-21.5c0.4-2.8,1.3-5.6,2.1-8.3
			c0.3-1,0.5-2,1.1-2.8c3.4-4.8,7.8-5.1,11.5-0.4c2.6,3.2,4.2,6.9,5.6,10.8c1.1,3,2,3.1,4,0.8c2.5-2.7,4.8-5.4,8.9-6.1
			c5.3-0.9,9.3,2.2,9.4,7.5c0,1.6-0.1,3.2-0.6,4.8c-1.1,3.7-1.1,3.9,2.4,5.7c3.6,1.8,6.8,3.7,8.2,7.8c0.6,1.6,0.3,2.7-0.7,4.4
			c-5.3,9.6-14,11.3-23.6,10.5C402.9,209.7,396.9,209.1,391.4,206.9z"
        />
      </g>
      <path
        fill="#608437"
        d="M276.1,13.8c-0.5,1-1.8,1-3,1.3c-2.2,0.5-4.4,0.4-6.6,0c-6.3-1-12.8-1.3-18.8-3.6c-2.9-1.1-5.2-0.2-7.2,2.1
		c-7,7.7-7.1,7.7,1.9,13.4c4.2,2.7,7.3,6.6,10.8,10c0.5,0.5,0.7,1.3,1,2c0.5,1.4,0.9,3-0.3,4.2c-1.2,1.2-2.5,1-4.1,0.5
		c-7.1-2.1-12.4-7-17.7-11.8c-0.7-0.7-1.2-1.6-1.9-2.3c-2.4-2.3-4.2-2.7-7.3-1.1c-2,1-4,2-5.7,3.4c-2.1,1.8-4.2,3.2-6.9,4.1
		c-3.6,1.3-4.1,2.6-2,6.2c2.9,4.9,5.6,9.9,9.2,14.3c1.9,2.3,3.7,4.6,4.5,7.6c0.7,3.1-0.8,5-3.8,4.1c-3.2-0.9-6.3-2.1-9-4.6
		c-5.6-5.2-9.3-11.5-12.6-18.1c-1.4-2.7-2.9-3.2-5.3-2.3c-5.8,2.2-11.9,3.2-18,4.2c-2.8,0.5-3.3,2-3.2,4.7
		c0.3,7.6,0.9,15.2,1.4,22.8c0.3,4.6,0.8,9.3-1,13.8c-0.5,1.2-0.7,2.4-2.1,2.7c-1.8,0.4-2.8-0.7-3.5-2c-0.7-1.3-1.6-2.6-1.9-4
		c-2.5-11.9-4.2-23.8-0.1-35.7c-2.1-1.7-4.8-1.5-7.1-1.6c-4.2-0.2-8.3-0.2-12.4-1.4c-3.6-1.1-4.5,0.1-4.6,4.1
		c-0.4,11.6-1.3,23.2-5.6,34.2c-1.2,3.1-3.6,3.8-6.1,1.6c-2.5-2.1-3-5.2-3-8.1c0-4.4,0.1-8.8,0.4-13.2c5.1-8.7,10.6-16.7,16.7-23.9
		c0.6,0,1.2-0.1,1.8-0.1c-0.1-0.6-0.2-1.1-0.3-1.6c2.9-3.4,5.9-6.5,9-9.4c0,1.1,0.1,2.2,0.5,3.3c0.9,3-2.4,6.6,0.4,9
		c2.6,2.3,6.1-0.1,9.3,0.2c6.3,0.5,12.4-0.7,18.5-3.1c-4.3-8.5-6.2-17.1-5.9-26.2c0-0.1,0-0.3,0-0.4c2.4-1.9,5.2-2.7,8.1-3.4
		c0,0,0,0,0.1,0c1-0.2,2.1-0.4,3.1-0.6c1.2,7.6,0.6,15.2,0,22.7c-0.1,0.9-0.8,1.8-1.2,2.7c-1.3,3.4-0.3,4.8,3,4.2
		c1.2-0.2,2.4-0.7,3.5-1.2c7.1-2.8,14.1-5.8,20.9-9.3c3.5-1.8,3.7-2,1.2-5.4c-4-5.5-6.2-11.6-6.5-18.4c0.6-0.2,1.2-0.4,1.8-0.5
		c0,0,0,0,0,0c3.6-1,7.3-1.2,11.1-1c0,0.2,0.1,0.3,0.2,0.5c1.6,5.6,2.5,11.4,2.9,17.6c5.6-3.3,9.5-7.2,13.6-11.1
		c1.6-1.5,3.4-3,4.5-4.9l0,0C251.8,6.7,263.8,9.7,276.1,13.8z"
      />
      <g>
        <path
          fill="none"
          d="M136.8,217.7L136.8,217.7L136.8,217.7C136.8,217.6,136.8,217.6,136.8,217.7L136.8,217.7"
        />
        <path
          fill="#608437"
          d="M102.6,117.2c1.6,2,3,4.1,4,6.7c2.5,5.9,2.3,12,1.2,17.8c-1.6,8.2-1.3,16.5-2.8,24.6
			c-1.2,6.9-3.1,13.5-6.6,19.6c-0.8,1.3-1.7,2.7-2.1,4.2c-0.6,2.4-0.8,5,1.5,6.8c2.1,1.7,6.8,1.4,8.7-0.7c2.3-2.6,5.3-4.9,5.8-8.8
			c0.7-5.6,3.5-10.8,3.2-16.7c-0.1-1.1,0-2.3,0.4-3.3c1.9-3.8,2-7.7,1.8-11.8c0-0.6,0.5-1.2,0.8-1.8c-0.4-0.7-1-1.4-0.2-2.2
			c0.2-0.2,0.8-0.4,1-0.3c1.2,0.8,0.8,1.7,0.2,2.6c3,2.9,4.3,6.8,5,10.6c2.2,10.9,4.1,21.9,5.8,32.8c0.7,4.8,0.6,9.8,0.8,14.7
			c0.2,5.1,0.2,5.1,5.4,5.7c1.9-12.7,1.2-25.2-3.4-37.4c-0.4-1-0.8-2.1-1-3.2c-1.4-8.4-3.7-16.5-6-24.6c-0.6-2.2-1.1-4.3-2.3-6.2
			c-1.1-1.8-1.6-3.5-0.8-5.8c5,3.3,9.4,6.9,13.6,10.9c2.6,2.4,5.6,3.5,8.9,4.3c1.5,0.4,2.6-0.3,3.1-1.8c-0.1-2.5-1.3-4.5-2.7-6.5
			c-8.1-6.3-16.3-12.6-24.4-19c-1.2-0.9-2.5-1.9-3.7-2.8c-2.6-2-4.9-3.9-6.4-7.3c-1.5-3.4-3.9-6.4-6.6-9.1L102.6,117.2z"
        />
        <path
          fill="#ef84ac"
          d="M136.8,217.7c-3.7,3.4-3.7,3.4-7,0c-0.9-1-2-1.8-3-2.7c-2.3-2.1-4.7-3.5-7.8-1.4c-3.3,2.1-6.1,4.5-6.1,8.9
			c0,0.7,0.1,1.4,0.4,2c1.1,2.6-0.1,4.2-2.3,5.5c-1.7,1-3.3,2.3-4.8,3.6c-2.8,2.3-3,5.5-0.4,8c1.8,1.8,3.9,3,6.5,3.3
			c3.6,0.5,5.3,2.4,5.9,6.1c0.9,6.2,5.5,9.7,11.5,9.9c2.3,0.1,3.1-0.9,3.8-2.8c1-2.6,1.1-5.2,1.1-7.9c0-1.8,1-3,3.1-2.1
			c3,1.2,6.1,1.5,9.2,0.8c5.3-1.1,6.9-5.8,3.2-10c-1.2-1.3-2.8-2.3-4.1-3.5c-2-1.8-2.3-3.5,0-4.9c3.9-2.2,3-5.1,2-8.1
			c-0.9-2.7-4.4-4.7-7.6-4.3C139.1,218.3,137.9,218.7,136.8,217.7L136.8,217.7z"
        />
      </g>
      <g>
        <path
          fill="#ef84ac"
          d="M361.5,120.8c-8.3-1.3-12.5-5.3-13.8-13.6c-0.6-4.2-1-8.4,0.8-12.7c1.5-3.5,3.9-5.4,7.3-6.1
			c15.6-3.2,23.7,5.7,26.5,18.1c1.1,4.8-1.4,8.8-5.6,11.4C372.1,120.8,366.9,121.7,361.5,120.8z"
        />
        <path
          fill="#ef84ac"
          d="M359.3,74.6c-0.9,0.9-1.9,1.3-3.1,1.4c-1.2,0.1-2.3,0.6-3.5,0.6c-1.5,0-3.1-0.2-5.8-0.4
			c-3.4,0.3-6.2-2.4-8.3-5.9c-1.2-2-2.4-4.1-3.2-6.2c-1.6-4-2-7.9,1.4-11.4c2.1-2.3,4.6-3.6,7.2-4c6.7,4.6,13.2,9.6,19.5,14.9
			C363.8,67.2,362.5,71.4,359.3,74.6z"
        />
        <path
          fill="#ef84ac"
          d="M318.3,100.6c-0.1-0.4-0.2-0.7-0.1-1.1c-0.3-2.3-0.6-4.6-0.8-7c-0.4-5.8,2.8-10.5,8.5-12.4
			c5.1-1.6,12,0.5,14.6,4.7c2.6,4,2.2,8.4,0.1,12.3c-2.4,4.5-6.6,7.2-11.7,8c-3.2,0.5-6.3,0.1-8.5-2.7
			C319.9,101.6,319.3,100.9,318.3,100.6z"
        />
      </g>
      <path
        fill="#608437"
        d="M449.4,327.5c-1.2-0.1-2.3-0.3-3.5-0.4c-3.6-0.4-6.7,0.2-9.7,2.6c-4.2,3.5-8.9,6.4-13.5,9.3
		c-3.5,2.2-6.5,5-9.1,8.2c-0.4,0.5-0.8,0.9-1.2,1.3c-1.4,1.3-2.7,3.1-4.9,2.5c-1.5-0.4-1.6-3.8,0-6.4c3-4.9,7.3-8.6,11.8-12.1
		c2.3-1.7,4.7-3.3,6.2-6.1c-2.4-2-5.5-2.1-8.1-2.6c-9.2-1.7-17.5-5.4-25.6-9.8c-3.4-1.8-3.9-2.8-3.5-6c0.3-2.1,1.1-2.7,3.3-1.9
		c4.6,1.7,9.1,3.4,13.7,5.3c3.7,1.5,7.5,2.1,11.3,3.1c4,1,7.9,2.2,11.8,3.7c5.8,2.2,11.9,3.7,18.3,3.4
		C448,323.4,449.8,324.9,449.4,327.5z"
      />
    </g>
  </svg>
</template>
